export const QUERY_KEY_TASKS_SINGLE_VOYAGES = 'tasks_single_voyage'
